import { call, fetchAllPages, fetchAllPagesWith } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST — CỔNG THẦU PHỤ ▸ ĐỐI SOÁT (F21) ═════════════════════════════════════════════
 * ⚠ KHÔNG cửa nào nhận `vendorId`: máy chủ lấy nó TỪ PHIÊN. Nếu ngày nào có một tham số như vậy
 *   xuất hiện ở đây thì đó là lỗi, không phải tiện ích.
 */
export type MyApInvoice = apiDto.VendorApInvoiceDto
export type ReconRow = apiDto.ReconRequestDto
export type ReconSummary = apiDto.ReconSummaryDto
export type MyRtPrice = apiDto.VendorRtPriceDto

const BASE = '/api/v1/ncc/doi-soat'

/** ⭐ Đi HẾT trang (dieu-hanh-6): NCC hơn 200 chứng từ vẫn thấy đủ; ba con số tổng máy chủ cộng trên toàn bộ (trang đầu mang theo). */
export const fetchMyApInvoices = (): Promise<{ rows: MyApInvoice[]; summary: ReconSummary }> =>
  fetchAllPagesWith<MyApInvoice, { summary: ReconSummary }>(`${BASE}/chung-tu?limit=200`)

export const ackInvoiceApi = (id: string, version: number): Promise<void> =>
  call<void>(`${BASE}/chung-tu/${id}/xac-nhan`,
    { method: 'POST', body: JSON.stringify({ version }) })

export const fetchMyRecon = (): Promise<ReconRow[]> => fetchAllPages<ReconRow>(BASE)

/** 💚 Giá "RT chốt" từng đơn đã nhận — cửa trả MỘT danh sách (không phân trang): chỉ đơn họ đã nhận có khoản của họ. */
export const fetchMyRtPrices = (): Promise<{ rows: MyRtPrice[] }> => call<{ rows: MyRtPrice[] }>(`${BASE}/gia-rt`)

export const sendReconApi = (body: Record<string, unknown>): Promise<ReconRow> =>
  call<ReconRow>(BASE, { method: 'POST', body: JSON.stringify(body) })
